import { IconLogoDefault } from '@mc/design-system'

// MC-logo tile with a short notice line, shown in hero sections when the
// viewer's membership already includes the program (subscriber / enterprise)
export const LogoNotice = ({ text }: { text: string }) => (
  <div className='flex items-center gap-4'>
    <span className='flex shrink-0 items-center justify-center size-[43px] rounded-md border border-c-beige-700'>
      <IconLogoDefault className='size-6 text-c-text-dark' />
    </span>
    <p className='c-body-small text-c-text-dark'>{text}</p>
  </div>
)
